const PROGRAMME_TYPE_MAPPING = {
  NOT_ENROLLED: "Not enrolled in programme",
  PREVENTION_PROGRAMME: "Prevention programme",
  CHRONIC_DISEASE_MANAGEMENT: "Chronic disease management programme",
  DEREGISTERED: "Deregistered",
};

export const getProgrammeTitle = (programmeType) =>
  PROGRAMME_TYPE_MAPPING[programmeType] ?? programmeType;
